// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-a686fff0]{\n  width: 800px;\n}\n#tblSecond[data-v-a686fff0]{\n  width: 1000px;\n}\n.btn[data-v-a686fff0]{\n  color: white !important;\n  margin: 5px;\n  /*width: 40px;*/\n}\n", ""]);
// Exports
module.exports = exports;
